import React from 'react'
import './LFlex.css'
import {luiClassName} from "../../utils/lui"
import PropTypes from "prop-types";


/**
 *  LFlex
 *
 *  @param {*} children
 *  @param {boolean} vertical
 *  @param {boolean} wrap
 *  @param {string} className
 *  @param {*} style
 *  @returns {JSX.Element}
 *  @constructor
 */
export default function LFlex({ children, vertical=false, wrap=false, className, style }){

    className = luiClassName([
        '-LFlex',
        vertical && 'vertical',
        wrap && 'wrap',
        className
    ])

    return (
        <div className={className} style={style}>{children}</div>
    )

}

LFlex.propType = {
    children:   PropTypes.any,
    vertical:   PropTypes.bool,
    wrap:       PropTypes.bool,
    className:  PropTypes.string,
    style:      PropTypes.object
}